import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

function useProvinces() {
  const [provinces, setProvinces] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const provinces = await dataProvider.getList("provinces", {});
        setProvinces(provinces.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    provinces,
    loading,
    error,
  };
}

export default useProvinces;
